import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3121dbc8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3121dbc8&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=3121dbc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3121dbc8",
  null
  
)

export default component.exports